export default "__VITE_ASSET__$mCzaozO__"